import { AerInputStructure } from "@aerstudios/aerated-aerinputstructure";
import { AerRadioGroup } from "@aerstudios/aerated-aerradiogroup";
import type { WidgetProps } from "@rjsf/utils";
import cx from "clsx";
import type { JSONSchema7 } from "json-schema";
import React from "react";
import * as styles from "./RadioGroup.module.scss";

type Props = WidgetProps<Props>;

export const RadioGroup: React.FC<Props> = ({
	readonly,
	value,
	onFocus: _onFocus,
	onBlur: _onBlur,
	autofocus: _autofocus,
	uiSchema: _uiSchema,
	...aerRadioGroupProps
}) => {
	const {
		formContext: _formContext,
		rawErrors: _rawErrors,
		hideLabel: _hideLabel,
		hideError: _hideError,
		schema,
		...aerRadioGroupPropsRest
	} = aerRadioGroupProps;
	const { anyOf, allOf, oneOf } = schema;

	const items = (anyOf || allOf || oneOf) as JSONSchema7[];

	return (
		<AerInputStructure.Root errorMessage={_rawErrors?.[0]}>
			<AerRadioGroup.Root
				{...aerRadioGroupPropsRest}
				tabIndex={0}
				id={`root_${aerRadioGroupPropsRest?.name}`}
				// autoFocus={autofocus}
				groupLabel={{ text: aerRadioGroupProps.label, hide: true }}
				value={value} // Required to force re-render so prefill data works
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						e.preventDefault();
					}
				}}
				unselectable={"on"}
			>
				{items?.filter((item) => item.title).map((answer, i) => {
					return (
						<AerRadioGroup.Item
							id={`root_${aerRadioGroupPropsRest?.name}-${i}`}
							key={answer.title}
							label={answer.title}
							value={answer.title}
							checkedIcon={<div className={styles.selectedRadio} />}
							readOnly={readonly}
							className={cx(styles.radioOption, {
								[styles.firstItem]: i === 0,
							})}
						/>
					);
				})}
			</AerRadioGroup.Root>
			<AerInputStructure.ErrorMessage />
		</AerInputStructure.Root>
	);
};
export default RadioGroup;
